import React, { Fragment, useEffect, useState } from 'react';
import { Button, Grid, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { updateSegment } from 'src/services/projectService';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import { AppActions } from 'src/store/AppReducer';
import { useAppSelector } from 'src/hooks/hooks';

export interface SegmentInformation {
  code: string;
  description: string;
  name: string;
  manager: string;
}

const EditForm = ({ toggle, open, data, getData, setSnackBarMessageS , setSnackbarSeverityS, setSnackBarOpenS }) => {
  const dispatch = useDispatch();
  const TextFieldStyle = {
    paddingTop: 2,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const { register, handleSubmit, reset } = useForm<SegmentInformation>();
  const [nameError, setNameError] = useState('');
  const [descError, setDescError] = useState('');
  const [segmentObj, setSegmentObj] = useState<any>({});

  const [openConfirmation, setOpenConfirmation] = useState(false);

  const toggleConfirmation = () => {
    if (
      segmentObj.name !== '' &&
      segmentObj.name.trim().length > 0 &&
      segmentObj.name.length < 31 &&
      segmentObj.description.length < 101
    ) {
      setNameError('');
      setOpenConfirmation(!openConfirmation);
    } else if (segmentObj.name === '') {
      setNameError('Segment name required');
    } else if (segmentObj.name.trim().length < 1) {
      setNameError('Segment name cannot be only spaces');
    }
  };

  useEffect(() => {
    setSegmentObj({
      name: data.name,
      id: data.id,
      description: data.description
    });
  }, [data, open]);

  const { isLoading } = useAppSelector((state) => state.appReducer);

  const onSubmit = () => {
    if (
      segmentObj.name !== '' &&
      segmentObj.name.length < 31 &&
      segmentObj.description.length < 101
    ) {
      dispatch(AppActions.showLoader());

      setNameError('');
      const body = {
        id: segmentObj.id,
        name: data.name === segmentObj.name ? null : segmentObj.name,
        description:
          data.description === segmentObj.description
            ? null
            : segmentObj.description
      };
      updateSegment(body)
        .then(() => {
          reset();
          setSnackBarMessageS('You have updated the segment successfully.');
          setSnackbarSeverityS('success');
          setSnackBarOpenS(true);
          getData();
          toggle();
          toggleConfirmation();
          dispatch(AppActions.hideLoader());
        })
        .catch((error) => {
          dispatch(AppActions.hideLoader());
          setSnackBarMessageS(error?.request?.response ? error?.request?.response : 'Unable to update segment.');
          setSnackbarSeverityS('error');
          setSnackBarOpenS(true);
          toggleConfirmation();
          toggle();
        });
    } else if (segmentObj.name === '') {
      setNameError('Segment name required');
    }
  };

  return (
    <Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid item xs={12} sx={{ pt: 3, pb: 1, pl: 2 }}>
          <Typography style={{ fontSize: '15px' }} variant="h3">
            Edit Segment
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Segment Name<span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              id="editSegmentName"
              name="editSegmentName"
              inputProps={{ maxLength: 30 }}
              size="small"
              {...register('name', {})}
              style={TextFieldStyle}
              fullWidth
              placeholder="Segment Name"
              variant="outlined"
              value={segmentObj.name}
              onChange={(e) => {
                if (e.target.value.length > 30) {
                  setNameError('Customer name must not exceed 30 characters');
                } else {
                  setNameError('');
                }
                setSegmentObj((prev) => ({ ...prev, name: e.target.value }));
              }}
            />
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {nameError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Segment Code
            </Typography>
            <TextField
              id="editSegmentCode"
              name="editSegmentCode"
              className="disabledTextbox"
              aria-readonly
              size="small"
              sx={{
                input: {
                  background: '#d1d1d1',
                  borderRadius: 0.5
                }
              }}
              {...register('code', {})}
              value={data.code}
              style={{
                ...TextFieldStyle,
                pointerEvents: 'none'
              }}
              fullWidth
              placeholder="Customer Code"
              variant="outlined"
              onChange={(e) => {
                setSegmentObj((prev) => ({ ...prev, code: e.target.value }));
              }}
            />
          </Grid>

          {/* <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Segment Manager<span style={{ color: 'red' }}>*</span>
          </Typography>
          <Select
            className="select-text"
            size="small"
            style={selectStyle}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            {...register('manager', {})}
            defaultValue={''}
          >
            <MenuItem style={{ display: 'none' }} selected disabled value={''}>
              Enter Segment Manager
            </MenuItem>
            {employees.map((element) => {
              return (
                element.employeeId != null && (
                  <MenuItem value={element.employeeId}>{element.name}</MenuItem>
                )
              );
            })}
          </Select>
          <Typography
            style={{
              paddingLeft: 15,
              paddingRight: 15,
              fontSize: '11px'
            }}
            color="red"
          >
            {managerError}
          </Typography>
        </Grid> */}
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Description
            </Typography>
            <TextField
              id="editSegmentDescription"
              name="editSegmentDescription"
              inputProps={{ maxLength: 100 }}
              size="small"
              {...register('description', {})}
              style={TextFieldStyle}
              fullWidth
              value={segmentObj.description}
              placeholder="Enter Description"
              variant="outlined"
              onChange={(e) => {
                if (e.target.value.length < 101) {
                  setDescError('');
                } else {
                  setDescError(
                    'Account description must not exceed 100 characters'
                  );
                }
                setSegmentObj((prev) => ({
                  ...prev,
                  description: e.target.value
                }));
              }}
              rows={2}
              multiline
            />
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {descError}
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              mb: 2,
              mt: 2,
              pr: 2,
              display: 'flex',
              justifyContent: 'flex-end'
            }}
            xs={12}
          >
            <Button
              id="editSegment-btn-onCancel"
              sx={{
                width: '10%',
                fontWeight: 'normal',
                background: '#F5F7FF',
                fontSize: '13px'
              }}
              onClick={toggle}
            >
              Cancel
            </Button>
            <Button
              id="editSegment-btn-onSubmit"
              disabled={segmentObj.name === '' || isLoading}
              className={isLoading ? 'loading' : ''}
              sx={{
                ml: 2,
                width: '10%',
                fontSize: '13px',
                fontWeight: 'normal',
                background: '#0069E4'
              }}
              variant="contained"
              type="button"
              onClick={() => toggleConfirmation()}
            >
              Update
            </Button>
          </Grid>
        </Grid>
      </form>

      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmation}
        toggle={toggleConfirmation}
        message={`Are you sure want to update this segment?`}
        onConfirm={() => onSubmit()}
        noToggle={toggleConfirmation}
      />
    </Fragment>
  );
};

export default EditForm;
